const scriptCache: {[key: string]: Promise<void> | undefined} = {};

export async function scriptLoader(
  url: string,
  scriptId: string,
): Promise<void> {
  if (scriptCache[scriptId]) return scriptCache[scriptId];

  scriptCache[scriptId] = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.id = scriptId;
    script.type = 'module';
    script.async = true;
    script.onload = () => {
      resolve();
    };
    script.onerror = (error) => {
      reject(error);
    };
    document.body.appendChild(script);
    script.src = url;
  });

  return scriptCache[scriptId];
}
